import { useAsset } from "../../AssetHelper";

import './Primary.scss'
import ScrollingText from "../components/ScrollingText";
import {Timeout} from "../displayContainer";
import { ReactNode, useContext } from "react";
import {t} from "../../i18n";
import DisplayParams from "../DisplayParams";
import {QRCodeSVG} from 'qrcode.react';
import {renderTime} from "../../utils";
import { RankingData } from "../rankingDataState";
import {ReactSVG} from "react-svg";
import EventName from "../components/EventName";

// TODO alternateCompact is a terrible name
export default function Primary({children, disableTimeout, qr, className, compact, alternateCompact} : {
    children: ReactNode,
    disableTimeout?: boolean
    qr?: string | null,
    className?: string,
    compact?: boolean,
    alternateCompact?: boolean
}) {
    const params = useContext(DisplayParams);
    const state = useContext(RankingData);
    const displayParams = useContext(DisplayParams);
    const sponsorSuffix = displayParams.alternatePresentingSponsor ? '_' + displayParams.alternatePresentingSponsor : '';
    const gameLogo = useAsset(compact ? `img/logos/decode_season_primary_wide${sponsorSuffix}.svg`: `img/logos/decode_season_primary_word${sponsorSuffix}.svg`)
    const programLogo = useAsset(displayParams.isFirstChampionship ? "img/logos/decode_fcmp_onecolor.svg" : undefined)
    const contextTimeout = useContext(Timeout)
    const timeout = disableTimeout ? {timer: {running: false, remaining: 0} } : contextTimeout;
    const name = <ScrollingText><EventName /></ScrollingText>;

    const qrBase = state[params.divisionNumber || 0] ? state[params.divisionNumber || 0].url : null;
    const qrElement = qrBase && qr && !compact ? <QRCodeSVG size={160} value={qrBase + (qr == "/" ? "" : qr)} /> : null;
    const logoComponent = qrElement ? <>
        <div className={"primaryQrWrapper"}> {qrElement}</div>
        <span className={"qrLabel"}>{(qrBase! + (qr == "/" ? "" : qr)).replace(/https?:\/\//, "")}</span>
    </> : <img className="gameLogo" src={programLogo ? programLogo : gameLogo} />
    return <div className={`h-100 w-100 ${className} ${displayParams.isFirstChampionship ? 'fcmp' : ''}`}>
        <div className={`primaryContainer ${timeout.timer.running ? 'timeout' : (qrElement ? 'qr' : '')}`}>
            <div className={`bottomBar ${compact ? 'compact' : ''} ${alternateCompact ? 'alternateCompact' : ''}`}>
                {alternateCompact ? null : logoComponent}
                <div className="eventInfo">
                    <div className="eventName">{params.isFirstChampionship && compact ? "" : name}</div>
                    {params.eventLocation || true ? <div className="eventLocation"><ScrollingText width="100%">{params.eventLocation}</ScrollingText></div> : null}
                </div>
                {programLogo && !alternateCompact ? <img className="gameLogo" src={gameLogo} /> : (alternateCompact ? logoComponent : null)}
            </div>
            {children}
        </div>
    </div>;
}